export default __webpack_public_path__ + "static/media/no-marbles-overlay.1624af03.png";